import { useUnits } from '@/hooks/useUnits'
import { DATA_PAGINATION, SetupStation } from '@/types'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { Stack } from '@mui/system'
import { FC } from 'react'
import useTranslation from '@/hooks/useTranslation'

interface StationTableProps {
  data?: DATA_PAGINATION<SetupStation>
}

const StationTable: FC<StationTableProps> = ({ data }) => {
  const { t } = useTranslation()

  const { convertLabelUnit, convertFromMetric } = useUnits()

  return (
    <Stack flexGrow="1" height="100%" justifyContent="space-between">
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ minWidth: '29px' }}>ID</TableCell>
              <TableCell sx={{ minWidth: '196px' }}>Decoder Name</TableCell>
              <TableCell sx={{ minWidth: '118.67px' }}>Address</TableCell>
              <TableCell sx={{ minWidth: '68px' }}>Index</TableCell>
              <TableCell sx={{ minWidth: '68px' }}>Type</TableCell>
              <TableCell sx={{ minWidth: '118.67px' }}>Configure</TableCell>
              <TableCell sx={{ minWidth: '119px' }}>Decoder Type</TableCell>
              <TableCell sx={{ minWidth: '59px' }}>Priority</TableCell>
              <TableCell sx={{ minWidth: '103px' }}>Pipe</TableCell>
              <TableCell sx={{ minWidth: '103px' }}>Soil</TableCell>
              <TableCell sx={{ minWidth: '105px' }}>Plant Group</TableCell>
              <TableCell sx={{ minWidth: '118.67px' }}>Emitter</TableCell>
              <TableCell sx={{ minWidth: '118.67px' }}>Area</TableCell>
              <TableCell sx={{ minWidth: '118.67px' }}>Sub-Area</TableCell>
              <TableCell sx={{ minWidth: '121px' }}>
                Emitter Efficiency
              </TableCell>
              <TableCell sx={{ minWidth: '144px' }}>
                {t('defaultRuntime')}
              </TableCell>
              <TableCell sx={{ minWidth: '144px' }}>
                {t('formsLabelsWaterRequired')} ({convertLabelUnit('mm')})
              </TableCell>
              <TableCell sx={{ minWidth: '166px' }}>
                {t('formsLabelsPrecipitationRate')} ({convertLabelUnit('mm/h')})
              </TableCell>
              <TableCell sx={{ minWidth: '138px' }}>
                {t('formsLabelsExpectedFlow')} ({convertLabelUnit('l/m')})
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.data?.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.id}</TableCell>
                <TableCell>{row.controller}</TableCell>
                <TableCell>{row.address}</TableCell>
                <TableCell>{row.index}</TableCell>
                <TableCell>{row.type}</TableCell>
                <TableCell>{row.configure}</TableCell>
                <TableCell>{row.decoderType}</TableCell>
                <TableCell>{row.priority}</TableCell>
                <TableCell>{row.pipe}</TableCell>
                <TableCell>{row.soil}</TableCell>
                <TableCell>{row.plant}</TableCell>
                <TableCell>{row.emitter}</TableCell>
                <TableCell>{row.areaName}</TableCell>
                <TableCell>{row.subAreaName}</TableCell>
                <TableCell>{row.emitterEfficiency}</TableCell>
                <TableCell>{row.defaultRunTime}</TableCell>
                <TableCell>
                  {convertFromMetric(row.waterRequired, 'mm')}
                </TableCell>
                <TableCell>
                  {convertFromMetric(row.precipitationRate, 'mm/h')}
                </TableCell>
                <TableCell>
                  {convertFromMetric(row.expectedFlow, 'l/m')}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  )
}

export default StationTable
